/** Sheets (Univer Workspace embed at /sheets) — Plan 1966 */
export const sheetsTranslations = {
  navName: "ชีต",
  iframeTitle: "Zaviago ชีต",
  loading: "กำลังเปิดชีต...",
  errorTitle: "เปิดชีตไม่สำเร็จ",
  errorBody: "เกิดข้อผิดพลาดระหว่างเข้าสู่ระบบ กรุณาลองอีกครั้ง",
  errorMissingIdentity: "ไม่พบข้อมูลร้านค้าหรือบัญชีของคุณ กรุณาเข้าสู่ระบบใหม่",
  retry: "ลองอีกครั้ง",
  notEnabledTitle: "ร้านของคุณยังไม่ได้เปิดใช้ชีต",
  notEnabledBody: "ชีตช่วยให้ทีมสร้างสเปรดชีต เอกสาร และสไลด์ร่วมกันได้ ติดต่อ Zaviago เพื่อเปิดใช้งาน",
  noAccessTitle: "คุณยังไม่มีสิทธิ์ใช้ชีต",
  noAccessBody: "บัญชีหรือร้านของคุณยังใช้ชีตไม่ได้ในตอนนี้ ลองสอบถามเจ้าของร้าน หรือติดต่อ Zaviago",
  contactSupport: "ไปที่ศูนย์ช่วยเหลือ",
} as const;
